import axios from "axios";

export const APP_TOKEN_NAME = "EmmaCare1234567890sjklwejrewjodlwh";

export const setAxiosToken = () => {
  if (localStorage[APP_TOKEN_NAME]) {
    axios.defaults.headers.common["x-auth-token"] =
      localStorage[APP_TOKEN_NAME];
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
};
